import { useReduxState } from 'hooks';
import api from 'api';
import { breakpoints } from 'styles';
import { Alert, ConfirmButton } from 'components/common';

import type { GetFeedbacksRes } from 'shared-types/responses';

interface Props {
  feedbacks: GetFeedbacksRes['feedbacks'];
  unreadCount: number;
  updateFeedbacks: () => Promise<void>;
}

const FeedbackUnread = ({ feedbacks, unreadCount, updateFeedbacks }: Props) => {
  const { messages } = useReduxState();

  const markAsRead = async () => {
    const response = await api.put(`/admin/courses/${feedbacks[0].courseId}`, {
      feedbackLastRead: feedbacks[0].createdAt
    });
    if (!response.data || !response.data.success) return false;
    await updateFeedbacks();
    return true;
  };

  return (
    <div className="unread">
      <div className="count">
        <Alert
          icon="envelope"
          text={`${unreadCount} ${messages.feedbackUnreadFeedbacks}`}
        />
      </div>

      <div className="confirm">
        <ConfirmButton
          actionText={messages.feedbackMarkAsRead}
          buttonIcon="check"
          buttonText={messages.feedbackMarkAsRead}
          buttonTextHideBreakpoint={breakpoints.small - 1}
          category="success"
          confirmText={messages.feedbackMarkAsReadConfirm}
          confirmTitle={messages.feedbackMarkAsRead}
          onConfirm={markAsRead}
          successMessage={messages.feedbackMarkAsReadSuccess}
        />
      </div>

      <style jsx>{`
        .unread {
          align-items: center;
          display: flex;
          width: 100%;
        }
        .count {
          flex-grow: 1;
          margin-right: 15px;
        }
      `}</style>
    </div>
  );
};

export default FeedbackUnread;
